export class ResultItems {
    success: boolean;
    message: string;
    
    constructor(obj?: any) {
        if (obj == null) {
            return;
        }
        Object.assign(this, obj);
    }
}